import type { EventHub, OnDomLoad, SilverfinEvents } from '@app/types'

export type ApplicationContext = {
  eventHub: EventHub<SilverfinEvents>
  globalObject: Window
  onDomLoad: OnDomLoad
  environment: Environment
}

export enum Environment {
  Development = 'development',
  Production = 'production',
  Test = 'test',
  Undetermined = 'undetermined',
}
